export const getTimezoneString = () =>
  typeof window === 'undefined'
    ? null
    : window.Intl?.DateTimeFormat().resolvedOptions()?.timeZone || null;

export default getTimezoneString;
